import SearchService from "../api/search"
import ArtifactService from "../api/artifact"
import ArchiveService from "../api/archive"
import i18n from '../i18n/index'

export const state = () => ({
    site: 'cmh',
    siteChanged: false,
    loading: false,
    loaded: false,
    facets: null,
    selected_facets: {},
    facets_query: '',
    query: null,
    url_query: null,
    search_type: null,
    type: 'artifact',
    refinements: null,
    locale: '',
    sort: 'title',
    order: 'asc',
    size: 24,
    page: 1,
    suggestions: []
})

export const actions = {
    async site({commit}, params) {
        let hostname = params.site;
        let site = 'cmh';
        if (hostname.includes('cwm') || hostname.includes('war') || hostname.includes('guerre')) {
            site = 'cwm';
        }
        //site = 'cwm'; // LOCAL TESTING

        // site = 'cwm';
        commit('setSite', site)
        commit('setSiteChanged', true)
    },
    async fetch({commit}) {
        commit('setLoading', true)
    },
    async suggestions({commit}, params) {
        await SearchService.suggestions(params.locale, params.query)
        .then((response) => {
                commit('setSuggestions', response.data)
            })
            .catch((error) => {
                console.log(`Collections API Error => ${error}`)
            })
    },
    async reset({commit, dispatch, state}) {
        let type = state.search_type == 'basic' ? 'all' : 'artifact';
        commit('setType', type)
        dispatch('results/type', type, {root: true})
        commit('setLocale', '')
        commit('setSort', 'title')
        commit('setOrder', 'asc')
        dispatch('results/sort_by', 'title,asc', {root: true})
        commit('setPage', 1)
        commit('setSize', 24)
        commit('setSelectedFacets',  {})
        commit('setFacetsQuery', [])
        commit('setQuery', [])
    },
    async resetFacets({commit, dispatch}) {
        commit('setSelectedFacets', {})
        dispatch('facetQuery')
    },
    async type({commit, state}, params) {
        if(state.loading) {
            return
        }
        commit('setType', params.type)
    },
    async searchType({commit, state}, params) {
        if(state.loading) {
            return
        }
        commit('setSearchType', params)
    },
    async addFacet({commit, state, dispatch}, params) {
        if(state.loading) {
            return
        }

        let newFacets = state.selected_facets || {};

        let storedFacet = newFacets[params.name];
        if (storedFacet && storedFacet.length > 0) {
            storedFacet.push(params.value);
        } else {
            newFacets[params.name] = [params.value];
        }

        commit('setSelectedFacets', newFacets)
        dispatch('facetQuery')
    },
    async removeFacet({commit, state, dispatch}, params) {
        if(state.loading) {
            return
        }
        let newFacets = state.selected_facets;

        let storedFacet = newFacets[params.name];
        if (storedFacet.length > 1) {
            let ind = storedFacet.findIndex(v => v == params.value);
            storedFacet.splice(ind,1);
        } else {
            delete newFacets[params.name];
        }

        commit('setSelectedFacets', newFacets)
        dispatch('facetQuery')
    },
    async facetQuery ({commit, state}) {
        // create array of filters to add to search terms

        if (state.selected_facets) {

            let filterArray = []
            for (let key in state.selected_facets) {
                state.selected_facets[key].forEach(facetOption => {
                    if (key == 'media') {
                        filterArray.push('_and', key, facetOption)
                    } else {
                        // This search should be _eq and not _contains
                        // _eq search is not working for all filters, since it needs to match exactly, including the case
                        filterArray.push('_and', key, '_eq', facetOption)
                    }
                })
            }

            commit('setFacetsQuery', filterArray.flat())
        } else {
            commit('setFacetsQuery', [])
        }
        
        // dispatch('update', {})
    },
    async update({state, dispatch, commit}, params) {
        if(state.loading) {
            return
        }

        let allParams = {
            locale: params.locale || state.locale,
            q: params.q || state.query,
            sort: params.sort || state.sort,
            page: params.page || state.page,
            size: params.size || state.size,
            order: params.order || state.order,
            type: params.type || state.type,
            urlString: params.urlString || state.url_query
        }
        if (params.urlString) commit('setUrlQuery', params.urlString)

        dispatch('results/view', params.view, {root: true})
        dispatch('results/type', params.type, {root: true})
        dispatch('results/sort_by', `${params.sort},${params.order}`, {root: true});
        dispatch('results/loading', true, {root: true});

        dispatch('search', allParams);
    },
    async search({commit, state, dispatch}, params) {
        if(state.loading) {
            return
        }

        // if (params.q != state.query) { 
        //     dispatch('reset')
        // } 

        commit('setLoading', true)
        commit('setType', params.type)
        commit('setLocale', params.locale)
        commit('setSort', params.sort)
        commit('setOrder', params.order)
        commit('setPage', params.page)
        commit('setSize', params.size)

        let qArray = params.q;
        if (state.facets_query) {
            qArray = qArray.concat(state.facets_query)
        }

        if (params.type == 'artifact') {
            await ArtifactService.search(params.locale, qArray, params.sort, params.order, params.page, params.size)
            .then((response) => {
                dispatch('results/counts', {params: params, q: qArray}, {root: true}).then(() => {
                    dispatch('results/list', response.data, {root: true})
                })
                commit('setFacets', response.data.facets)
                commit('setQuery', params.q)
                commit('setLoading', false)
            })
            .catch((error) => {
                commit('setLoading', false)
                dispatch('results/list', [], {root: true})
                console.log(`Collections API Error => ${error}`)
            })
        } else if (params.type == 'archive') {
            await ArchiveService.search(params.locale, qArray, params.sort, params.order, params.page, params.size)
            .then((response) => {
                dispatch('results/counts', {params: params, q: qArray}, {root: true}).then(() => {
                    dispatch('results/list', response.data, {root: true})
                })
                commit('setFacets', response.data.facets)
                commit('setQuery', params.q)
                commit('setLoading', false)
            })
            .catch((error) => {
                commit('setLoading', false)
                dispatch('results/list', [], {root: true})
                console.log(`Collections API Error => ${error}`)
            })
        } else {
            await SearchService.search(params.locale, qArray, params.sort, params.order, params.page, params.size, params.type)
            .then((response) => {
                    dispatch('results/counts', {params: params, q: qArray}, {root: true}).then(() => {
                        dispatch('results/list', response.data, {root: true})
                    })
                    commit('setFacets', response.data.facets)
                    commit('setQuery', params.q)
                    commit('setLoading', false)
                })
                .catch((error) => {
                    commit('setLoading', false)
                    dispatch('results/list', [], {root: true})
                    console.log(`Collections API Error => ${error}`)
                })
    
        }
    },
    async refinements({commit}, params) {
        let filters = [];
        let getOptions = ['cmh-event','cmh-filtered.events']
        for( let i = 0; i < params.filters.length; i++ ) {
            let filterObj = params.filters[i];
            if (getOptions.includes(`${params.site}-${filterObj.api_field}`)) {
                filterObj['options'] = [
                    {'text': `${params.locale == 'en' ? 'all' : 'tout'}`, 'value': 'all'}
                ]
                let type = params.type;

                await SearchService.refinementOptions(params.locale, type, params.filters[i].api_field)
                .then((response) => {
                    response.data.forEach(o => {
                        filterObj['options'].push({'text': o, 'value': o})
                    });
                    filters.push(filterObj);
                })
                .catch((error) => {
                    commit('setLoading', false)
                    console.log(`Collections API Error => ${error}`)
                })
            } else {
                filters.push(filterObj)
            }
        }
        commit('setRefinements', filters )
    },
}

export const mutations = {
    setSite(state, site) {
        state.site = site
    },
    setSiteChanged(state, site) {
        state.siteChanged = site
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setQuery(state, data) {
        state.query = data;
    },
    setUrlQuery(state, data) {
        state.url_query = data;
    },
    setResults(state, data) {
        state.results = data
        state.loaded = true
        state.loading = false
    },
    setFacets(state, data) {
        state.facets = data;
    },
    setFacetsQuery(state, data) {
        state.facets_query = data;
    },
    setSelectedFacets(state, data) {
        state.selected_facets = data;
    },
    setType(state, data) {
        state.type = data;
    },
    setRefinements(state, data) {
        state.refinements = data;
    },
    setSearchType(state, data) {
        state.search_type = data;
    },
    setLocale(state, data) {
        state.locale = data;
    },
    setSort(state, data) {
        state.sort = data;
    },
    setOrder(state, data) {
        state.order = data;
    },
    setSize(state, data) {
        state.size = data;
    },
    setPage(state, data) {
        state.page = parseInt(data);
    },
    setSuggestions(state, data) {
        state.suggestions = data;
    },
}

export const getters = {
    json_ld(state, getters, rootState) {
        let site_content = i18n.messages[i18n.locale].main[state.site]
        let page_content = i18n.messages[i18n.locale].results_page
        let json = {
            "@context": "http://schema.org",
            "@type": "SearchResultsPage",
            "name": site_content.site_name,
            "description": site_content.description,
            "url": site_content.site_root,
            "potentialAction": {
                "@type": "SearchAction",
                "target": site_content.site_root,
                "query": "required"
            }
        }
        if (rootState.results.all_count) {
            json["mainEntity"] = [{
                "@type": "ItemList",
                "name": page_content.title
            }]
        }
        return json
    },
    site(state) {
        return state.site;
    },
    siteChanged(state) {
        return state.siteChanged;
    },
    loading(state) {
        return state.loading;
    },
    query(state) {
        return state.query;
    },
    url_query(state) {
        return state.url_query;
    },
    facets(state) {
        return state.facets;
    },
    selected_facets(state) {
        return state.selected_facets;
    },
    type(state) {
        return state.type;
    },
    refinements(state) {
        return state.refinements;
    },
    search_type(state) {
        return state.search_type;
    },
    locale(state) {
        return state.locale;
    },
    sort(state) {
        return state.sort;
    },
    order(state) {
        return state.order;
    },
    size(state) {
        return state.size;
    },
    page(state) {
        return state.page;
    },
    suggestions(state) {
        return state.suggestions;
    },
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
